import type { SxProps, Theme } from '@mui/material/styles';

export const cookieConsentBannerStyles: Record<string, SxProps<Theme>> = {
  container: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: (theme) => theme.zIndex.snackbar,
    p: 2,
  },
  content: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: { xs: 'stretch', sm: 'center' },
    justifyContent: 'space-between',
    gap: 2,
    maxWidth: 960,
    mx: 'auto',
  },
  text: {
    flex: 1,
  },
  actions: {
    display: 'flex',
    gap: 1,
    flexShrink: 0,
  },
};
